import { EditSample } from 'component'
import Button from 'meinian-package/src/baseComponent/button'
import React, { useContext } from 'react'
import { AccountContext } from '../../../../context'

/**
* 新建样衣 按钮
*/
export default
function BtnAddSampleClothing({ onClick }) {
  const { userInfo = {}, teamInfo = {} } = useContext(AccountContext) as unknown as { userInfo: any, teamInfo: any }
  const [visible, setVisible] = React.useState(false)
  return <>
    <Button type="primary" onClick={() => { setVisible(true) }}>新建样衣</Button>
    {visible ? <EditSample
      visible={visible}
      setVisible={setVisible}
      onChange={() => onClick?.()}
      accountInfo={userInfo}
      teamInfo={teamInfo}
    /> : null}
  </>
}
